import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { dreamTimes } from "source/app/presentation/MainPanel/Dreams/DreamTimes/DreamTimes";
import { QuickSelector } from "source/app/presentation/Shared/QuickSelector/QuickSelector";
import { GetQuickSelectorValues } from "source/app/presentation/Shared/QuickSelector/Value/GetQuickSelectorValues";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { dreamService } from "motw_core/Services/DreamService";
import { Sounds } from "source/app/services/Sound/Sounds";
import { UpdateLocalDreamState } from "./UpdateLocalDreamState";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function DreamDifficultyQuickSelector({
    show,
    setShow,
    dream,
}: {
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    dream: IDream;
}) {
    if (!show) {
        return null;
    }

    return (
        <div
            style={{
                display: `flex`,
                justifyContent: `center`,
                width: `100%`,
                margin: `6px 0 2px`,
            }}
        >
            <QuickSelector
                id="dreamDifficultyQuickSelector"
                allValues={GetQuickSelectorValuesFromDreamTimes()}
                selectedValue={dream.difficulty}
                OnSelect={async (value) => {
                    await HandleDreamDifficultyQuickSelectionAsync(
                        dream,
                        value
                    );

                    setShow(false);
                }}
                isOK={true}
                isExpired={false}
                label=""
                optionClasses={difficultyOptionStyleClass}
            />
        </div>
    );
}

const difficultyOptionStyleClass = StyleClass(
    `dreamDifficultyQuickSelector_option`,
    {
        borderRadius: `4px`,
        ":hover": {
            color: `hsl(47deg 88% 78%)`,
            background: `hsl(42deg 72% 52% / 0.12)`,
            boxShadow: `0 0 7px hsl(43deg 85% 62% / 0.22)`,
        },
    }
);

export async function HandleDreamDifficultyQuickSelectionAsync(
    dream: IDream,
    value: number,
    updateLocalState: boolean = true
) {
    Sounds.switch_toggle.Play({ allowConcurrent: true });
    const updatedDream = Object.assign({}, { ...dream, difficulty: value });

    if (updateLocalState) {
        UpdateLocalDreamState(updatedDream);
    }

    await dreamService.UpdateDreamAsync(updatedDream, ClientDataProvider);
}

function GetQuickSelectorValuesFromDreamTimes() {
    var values = dreamTimes.map((dt) => dt.difficulty);
    var result = GetQuickSelectorValues(values, () => undefined);
    return result;
}
